







































import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';

export default {
  name: 'uOttawa1321Prelab4Q2',
  components: {
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    const browserLanguage = navigator.language.split('-')[0]; // Extract the language code
    return {
      inputs: {
        studentAnswer: null,
        language: browserLanguage === 'fr' ? 'fr' : 'en', // Set the initial language based on browser preference
      },
      options: [
        {text: '0 stereoisomers', value: '0'},
        {text: '1 stereoisomers', value: '1'},
        {text: '2 stereoisomers', value: '2'},
        {text: '3 stereoisomers', value: '3'},
        {text: 'Up to 4 stereoisomers', value: '4'},
      ],
      optionsFr: [
        {text: '0 stéreoisomeres', value: '0'},
        {text: '1 stéreoisomère', value: '1'},
        {text: '2 stéreoisomères', value: '2'},
        {text: '3 stéreoisomères', value: '3'},
        {text: "Jusqu'à 4 stéreoisomères", value: '4'},
      ],
    };
  },
};
